import { QueovalBase } from '../global';

export class InseeModel extends QueovalBase {
  public ListInseeQueovalValues: Array<ListInseeQueovalValues>;
  public ListQueovalValue: Map<string, string>;
}

export class ListInseeQueovalValues {
  public Origin: string;
  public List: Array<InseeQueovalValues>;
}
export class InseeQueovalValues {
  public Insee: string;
  public Queoval: string;
  public Value: string;
  constructor(INSEE: string = '', queoval: string = '', value: string = '') {
    this.Insee = INSEE;
    this.Queoval = queoval;
    this.Value = value;
  }
}
